import { insertAuditLog } from '@/lib/dataService';
import type { AuditLog } from '@/types/domain';

export const AUDIT_EVENT = 'neozoo:audit-entry';

export function addAuditEntry(entry: Omit<AuditLog, 'id' | 'createdAt'>) {
  const newEntry: AuditLog = {
    ...entry,
    id: crypto.randomUUID(),
    createdAt: new Date().toISOString(),
  };
  insertAuditLog(newEntry as unknown as Record<string, unknown>).catch((error) => {
    console.error('Failed to persist audit entry:', error);
  });
  window.dispatchEvent(new CustomEvent<AuditLog>(AUDIT_EVENT, { detail: newEntry }));
  return newEntry;
}
